<section class="toggle-form" [ngClass]="{ active: isChangeControlSliderOpen }">
  <div class="formwrap">
    <div>
      <p-button
        appPreventDoubleClick
        styleClass="p-button-text"
        id="changeControlSliderCloseButton"
        type="button"
        label="Close"
        (debounceClick)="closeSlider()"
      ></p-button>
    </div>
    <div class="general-container">
      <p-tabView [(activeIndex)]="activeTab" (onChange)="onTabChange($event)">
        <p-tabPanel 
        header="General"
        [disabled]="!isChangeControlEditSlider"
        [rightIcon]="errorIconClassForTab">
          <div class="content">
            <app-change-control-general-details
            [changeControlDetails]="changeControlDetails"
            (activateTabIndex)="openCurrentTab($event)"
            ></app-change-control-general-details>
          </div>
        </p-tabPanel>
        <p-tabPanel   
        header="Attachments"
        [disabled]="!isChangeControlEditSlider"
         >
      <app-change-control-files (activateTabIndex)="openCurrentTab($event)" ></app-change-control-files>
      </p-tabPanel>
        <p-tabPanel 
        header="Related Documents"
        [disabled]="!isChangeControlEditSlider"
        [rightIcon]="errorIconClassForFilesTab">
          <div class="content">
            <app-change-control-related-documents
            (activateTabIndex)="openCurrentTab($event)"></app-change-control-related-documents>
          </div>
        </p-tabPanel>
      </p-tabView>
    </div>
  </div>
</section>
